/** Backend sends line item price as a decimal string (e.g. "367.0"). Returns cents, or null if unparseable. */
export function parseLineItemPriceInCents(
  price: string | number | null | undefined,
): number | null {
  const priceValue =
    typeof price === "number" ? price : parseFloat(String(price ?? ""));
  return Number.isFinite(priceValue) ? Math.round(priceValue * 100) : null;
}
